import { ApiClient } from "@modules/core/api/client/apiClient"
import { PayoutApiGateway } from "@modules/financesPayout/gateway/payoutApiGateway"
import {
  PayoutDetailsDto,
  PayoutDetailsDtoSchema,
  PayoutItemDto,
  PayoutItemDtoSchema,
} from "@modules/financesPayout/gateway/payoutDto"

export enum PayoutEnumApi {
  OWNER = "OWNER",
  ATHLETE = "ATHLETE",
}

export class PayoutApi implements PayoutApiGateway {
  private baseBoxUrl = "/box/financial"
  private baseAtheleUrl = "/financial"

  private getBaseUrl = (api: PayoutEnumApi) => {
    switch (api) {
      case PayoutEnumApi.OWNER:
        return this.baseBoxUrl
      case PayoutEnumApi.ATHLETE:
        return this.baseAtheleUrl
    }
  }

  constructor(private api: ApiClient) {}

  async getPayouts(api: PayoutEnumApi): Promise<PayoutItemDto[]> {
    const result = await this.api.get<PayoutItemDto[]>(`${this.getBaseUrl(api)}/payouts`)
    return result.data.map((payout) => PayoutItemDtoSchema.parse(payout))
  }

  async getPayout(api: PayoutEnumApi, payoutId: string): Promise<PayoutDetailsDto> {
    const result = await this.api.get<PayoutItemDto>(`${this.getBaseUrl(api)}/payouts/${payoutId}`)
    return PayoutDetailsDtoSchema.parse(result.data)
  }
}
